import React, { useState } from "react";
import "./EnterName.css";
import "../../../App.css";
import { useDispatch } from "react-redux";
import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
import { updateUser } from '../../../api/auth';
import { setUserDetails } from "../../../Redux/Slices/userDetailsSlice";
import { getUserId, getToken } from "../../../api/index";

function EnterName() {
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nickName, setNickName] = useState("");
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  // Name validation function
  const validateName = (name, fieldName, isRequired = true) => {
    if (!name.trim()) {
      return isRequired ? `${fieldName} is required` : "";
    }

    // Check length (2-50 characters)
    if (name.trim().length < 2) {
      return `${fieldName} must be at least 2 characters long`;
    }
    if (name.trim().length > 50) {
      return `${fieldName} must be less than 50 characters`;
    }

    // Check for valid characters (letters, spaces, hyphens, apostrophes)
    const nameRegex = /^[a-zA-Z\s\-']+$/;
    if (!nameRegex.test(name)) {
      return `${fieldName} can only contain letters, spaces, hyphens, and apostrophes`;
    }

    // Check for multiple consecutive spaces
    if (/\s{2,}/.test(name)) {
      return `${fieldName} cannot contain multiple consecutive spaces`;
    }

    // Check for leading/trailing spaces
    if (name !== name.trim()) {
      return `${fieldName} cannot start or end with spaces`;
    }

    // Check for consecutive special characters
    if (/[-']{2,}/.test(name)) {
      return `${fieldName} cannot contain consecutive hyphens or apostrophes`;
    }

    return "";
  };

  const validateAllFields = () => {
    const newErrors = {};
    
    // Validate each field
    const firstNameError = validateName(firstName, "First Name", true);
    const middleNameError = validateName(middleName, "Middle Name", false);
    const lastNameError = validateName(lastName, "Last Name", true);
    const nickNameError = validateName(nickName, "Nick Name", false);

    if (firstNameError) newErrors.firstName = firstNameError;
    if (middleNameError) newErrors.middleName = middleNameError;
    if (lastNameError) newErrors.lastName = lastNameError;
    if (nickNameError) newErrors.nickName = nickNameError;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFirstName = (e) => {
    setFirstName(e.target.value);
    // Clear error for this field when user starts typing
    if (errors.firstName) {
      setErrors(prev => ({ ...prev, firstName: "" }));
    }
  };

  const handleMiddleName = (e) => {
    setMiddleName(e.target.value);
    if (errors.middleName) {
      setErrors(prev => ({ ...prev, middleName: "" }));
    }
  };

  const handleLastName = (e) => {
    setLastName(e.target.value);
    if (errors.lastName) {
      setErrors(prev => ({ ...prev, lastName: "" }));
    }
  };

  const handleNickName = (e) => {
    setNickName(e.target.value);
    if (errors.nickName) {
      setErrors(prev => ({ ...prev, nickName: "" }));
    }
  };

  const handleNextClick = async () => {
    if (!validateAllFields()) {
      return;
    }
    try {
      const data = await updateUser({
        userId: getUserId(),
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        middleName: middleName.trim(),
        nickName: nickName.trim(),
        formProgress: 'name completed', 
      }, getToken());
      console.log(" response from update user api:", data);
      dispatch(setUserDetails(data.userDetails));
      dispatch(setActiveComponent("enterPersonalDetails"));
    } catch (error) {
      console.error("Update User API error:", error);
      setErrors({ general: "Update User Failed. Please try again." });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleNextClick();
    }
  };

  return (
    <div className="EnterName">
      <div className="enterNameComponent">
        <span className="signInText">Sign Up</span>
        <div className="rectangleBoxContainer">
          <div className="rectangleBox coloured"></div>
          <div className="rectangleBox"></div>
          <div className="rectangleBox"></div>
        </div>
        <span className="signInText2">
          Enter your full name as it appears on{" "}
        </span>
        <span className="signInText2">Government ID</span>
        <div className="nameInputContainer">
          <div className="generalInputContainer">
            <label htmlFor="firstName" className="labelText">
              First Name *
            </label>
            <div className="inputContainerWrapper">
              <input
                id="firstName"
                className="input"
                type="text"
                placeholder="Type your First Name"
                value={firstName}
                onChange={(e) => handleFirstName(e)}
                onKeyDown={handleKeyPress}
              />
              {errors.firstName && <span className="errorTooltip">{errors.firstName}</span>}
            </div>
          </div>
          <div className="generalInputContainer">
            <label htmlFor="middleName" className="labelText">
              Middle Name
            </label>
            <div className="inputContainerWrapper">
              <input
                id="middleName"
                className="input"
                type="text"
                placeholder="Type your Middle Name"
                value={middleName}
                onChange={(e) => handleMiddleName(e)}
                onKeyDown={handleKeyPress}
              />
              {errors.middleName && <span className="errorTooltip">{errors.middleName}</span>}
            </div>
          </div>
          <div className="generalInputContainer">
            <label htmlFor="lastName" className="labelText">
              Last Name *
            </label>
            <div className="inputContainerWrapper">
              <input
                id="lastName"
                className="input"
                type="text"
                placeholder="Type your Last Name"
                value={lastName}
                onChange={(e) => handleLastName(e)}
                onKeyDown={handleKeyPress}
              />
              {errors.lastName && <span className="errorTooltip">{errors.lastName}</span>}
            </div>
          </div>
          <div className="generalInputContainer">
            <label htmlFor="nickName" className="labelText">
              Nick Name
            </label>
            <div className="inputContainerWrapper">
              <input
                id="nickName"
                className="input"
                type="text"
                placeholder="Type your Nick Name"
                value={nickName}
                onChange={(e) => handleNickName(e)}
                onKeyDown={handleKeyPress}
              />
              {errors.nickName && <span className="errorTooltip">{errors.nickName}</span>}
            </div>
          </div>
        </div>
        {errors.general && <span className="errorTooltip" style={{ textAlign: 'center', marginBottom: '10px' }}>{errors.general}</span>}
        <button className="btnContainer" onClick={handleNextClick}>
          <span className="btnText">Next</span>
        </button>
      </div>
    </div>
  );
}

export default EnterName;
